import client from './client';

export interface DataSourceEntity {
  id: string;
  name: string;
  type: 'static' | 'api' | 'websocket' | 'sql' | 'mqtt';
  config: Record<string, unknown>;
  refreshInterval?: number;
  userId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export async function fetchDataSources(): Promise<DataSourceEntity[]> {
  const { data } = await client.get('/data-sources');
  return data;
}

export async function createDataSource(body: Omit<DataSourceEntity, 'id'>): Promise<DataSourceEntity> {
  const { data } = await client.post('/data-sources', body);
  return data;
}

export async function updateDataSource(id: string, body: Partial<DataSourceEntity>): Promise<DataSourceEntity> {
  const { data } = await client.put(`/data-sources/${id}`, body);
  return data;
}

export async function deleteDataSource(id: string): Promise<void> {
  await client.delete(`/data-sources/${id}`);
}

/** 数据源连通性测试（经后端代理，mqtt 可订阅返回；sql 返回受控提示） */
export async function testDataSource(type: 'sql' | 'mqtt', config: Record<string, unknown>): Promise<unknown> {
  const { data } = await client.post('/proxy/query', { type, config }, { timeout: 15000 });
  return data;
}

// ── B2：AI 数据源草稿（自然语言 → 草稿 JSON；人工确认后落库） ──
export type DataSourceDraftType = 'rest' | 'websocket' | 'mqtt' | 'static';

export interface DataSourceDraft {
  name: string;
  type: DataSourceDraftType;
  config: Record<string, unknown>;
  refreshInterval?: number;
  parser?: Record<string, unknown>;
}

export async function aiDraftDataSource(prompt: string): Promise<{ draft: DataSourceDraft; warnings: string[]; source: 'llm' }> {
  const { data } = await client.post('/data-sources/ai-draft', { prompt }, { timeout: 60000 });
  return data;
}

export async function testDataSourceConnection(
  type: DataSourceDraftType,
  config: Record<string, unknown>,
): Promise<{ ok: boolean; message: string; detail?: Record<string, unknown> }> {
  const { data } = await client.post('/data-sources/test-connection', { type, config }, { timeout: 20000 });
  return data;
}
